import app from './app'
import account from './account'
import auth from './auth'

export default {
  app,
  account,
  auth
}



// WEBPACK FOOTER //
// ./src/store/modules/index.js